
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StockERPDTO } from 'src/app/model/stockERPDTO';
import { ColorERP } from 'src/app/model/ColorERP';
import { PreciosERP } from 'src/app/model/preciosERP';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class PrecioERPService {
    private url : string = `${environment.HOST_ERP}`;

  //private url : string = "api_erp";
    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

      
   

      


 getPrecioERP(_modelo:String,_clave:String,_colorId:number,_talla:String):Observable<PreciosERP[]>{
    return this.http.get<PreciosERP[]>(`${this.url}/precio?modelo=${_modelo}&claveMarca=${_clave}&colorId=${_colorId}&Talla=${_talla}`);
    
 }



}